import {useDispatch, useSelector} from 'react-redux';
import {agyleAssessmentList} from '../../../../store/reducers/dicts';
import AssessmentFormFilled from './components/assessmentFormFilled';
import AssessmentsHeader from './assessmentsHeader';
import {useEffect, useState} from 'react';
import _ from 'lodash';
import {ctxAssessmentFilters, filterAssessmentList} from '../../../../store/reducers/patientContext';

const AssessmentView = ({patient, disableSave}) => {
    const dispatch = useDispatch();

    // Selectors
    const assessmentList = useSelector(agyleAssessmentList);
    const filter = useSelector(ctxAssessmentFilters);

    const [list, setList] = useState([]);

    useEffect(() => {
        const onlyActive = _.filter(assessmentList, {active: true});
        setList(dispatch(filterAssessmentList(onlyActive)));
    }, [assessmentList, filter]);

    return (
        <>
            <AssessmentsHeader/>
            <div>
                {list.map(assessment => (
                    <AssessmentFormFilled
                        key={assessment.__id}
                        patient={patient}
                        assessment={assessment}
                        disableSave={disableSave}
                    />
                ))}
            </div>
        </>
    );
};

export default AssessmentView;